import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  textMonarcha: {
    fontFamily: 'monarcha,open-sans !important',
    textTransform: 'uppercase !important',
    color: 'white ',
    fontWeight: 'bold !important',
  },
  textOpenSans: {
    fontFamily: 'open-sans,san-serif !important',
    textTransform: 'normal',
    color: 'white',
  },
}));

export default function ScalabilityDrives__Valuation(props) {
  const classes = useStyles();

  return (
    <Box sx={{ width: '60vw', height: '100%', paddingTop: 4 }}>

        <Typography
          className={props.fontStyle}
          variant="subtitle1"
          sx={{
            color: '#ffffff44',
            lineHeight: 1.3,
            textAlign: 'center',
            marginTop: 0,
            marginBottom: 2,
            fontSize: '11px !important',

          }}
        >
          Build a $1B personal brand by{' '}
          <span style={{ color: '#ffbf12' }}>
            converting followers into buyers,
            <br />
            like startups turning users into customers.
            <br />
            <br />
            Selling shoutouts on PassionStocks ties* your Personal brand valuation
            <br />
            to follower growth across all your social media platforms*.
            <br />
            <br />
            As your followers compound & convert, your brand value increases.
          </span>
          <br />
          <br />
          Achieving a $1B brand can <span style={{ color: '#ffbf12' }}>also</span> be done{' '}
          <span style={{ color: '#ffbf12' }}>collectively</span> by partnering <br />
          with other creators to sell shoutouts and/or merging brand assets.
        </Typography>
        <Typography
          className={classes.textOpenSans}
          variant="caption"
          sx={{
            position: 'relative',
            display: 'block',
            color: '#ffffff44',
            lineHeight: 1.3,
            width: '90%',
            marginRight: 'auto !important',
            marginLeft: 'auto !important',
            fontWeight: 'lighter',          fontSize: '8px !important',
          }}
        >
          *Valuation depends on multiple factors, such as follower engagement and whether buyers
          come from your follower base, among others. <a style={{ textDecoration: 'underline' }} href="https://support.passionstocks.com/articles/122673-how-does-the-personal-brand-calculator-work">Learn more</a>
        </Typography>
        <br />
        <img
          src={"/images/scalability-drives-valuation.png"}
          alt="Brand synergy"
          style={{ display: 'block', margin: '15px auto 0', width: '90%' }}
        />
      </Box>
  );
}
